export class PrepaymentInstallments {
  numberOfInstallments: number;
  amount: number;

  constructor(data: any | PrepaymentInstallments | DjangoPrepaymentInstallments = {}) {
    if (data instanceof PrepaymentInstallments) {
      bindPrepaymentInstallmentsData(this, data);
    } else {
      bindDjangoPrepaymentInstallmentsData(this, data);
    }
  }
}

export interface DjangoPrepaymentInstallments {
  number_of_installments: number;
  amount: number;
}

function bindPrepaymentInstallmentsData(
  prepaymentInstallments: PrepaymentInstallments,
  data: PrepaymentInstallments,
) {
  prepaymentInstallments.numberOfInstallments = data.numberOfInstallments;
  prepaymentInstallments.amount = data.amount;
}

function bindDjangoPrepaymentInstallmentsData(
  prepaymentInstallments: PrepaymentInstallments,
  data: DjangoPrepaymentInstallments,
) {
  prepaymentInstallments.numberOfInstallments = data.number_of_installments;
  prepaymentInstallments.amount = data.amount;
}
